<template>
  <div class="gc-page-project-wrap">
    <van-nav-bar class="gc-header-nav" :border="false"
                 title="事件详情"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="page-status-wrap box">
      <div class="status" v-if="detailInfo.IncidentStatus==0">
        <img src="@/assets/s-waiting.png" alt="">
        <span>待审核</span>
      </div>
      <div v-else-if="detailInfo.IncidentStatus==1||detailInfo.IncidentStatus==4">
        <div class="status">
          <img src="@/assets/s-ongoing.png" alt="">
          <span>进行中</span>
        </div>
        <div class="time-wrap" v-if="countDownTime>0">距离结束还有：
          <van-count-down class="time" :time="countDownTime"/>
        </div>
      </div>
      <div class="status" v-else-if="detailInfo.IncidentStatus==2">
        <img src="@/assets/s-waiting.png" alt="">
        <span>待验收</span>
      </div>
      <div class="status" v-else-if="detailInfo.IncidentStatus==3">
        <img src="@/assets/s-success.png" alt="">
        <span>已完成</span>
      </div>
    </div>
    <div class="page-project-record-wrap box">
      <van-steps direction="vertical" :active="-1" v-if="detailInfo.AuditList.length>0">
        <van-step v-for="(item,index) in detailInfo.AuditList" :key="index">
          <p>处理时间：{{ item.CreateTime }}</p>
          <h3>处理过程：{{ item.Content }}</h3>
          <div class="img-wrap" v-if="item.AuditImgs.length>0">
            <img @click="imgpreview(item.AuditImgs)" v-for="(src,i) in item.AuditImgs" :src="src" alt="" :key="i">
          </div>
        </van-step>
      </van-steps>
    </div>
    <div class="page-project-wrap box">
      <div class="item">
        <span>截止日期：</span>{{ detailInfo.EndTime }}
      </div>
      <div class="item">
        <span>处理人员：</span>{{ detailInfo.DealUserName }}
      </div>
      <div class="item">
        <span>事件紧急度：</span>
        <b v-if="detailInfo.IncidentLevel=='A'" class="b i1">{{ detailInfo.IncidentLevel }}</b>
        <b v-else-if="detailInfo.IncidentLevel=='B'" class="b i2">{{ detailInfo.IncidentLevel }}</b>
        <b v-else class="b">{{ detailInfo.IncidentLevel }}</b>
      </div>
      <div class="item">
        <span>处理要求：</span>{{ detailInfo.IncidentRequire }}
      </div>
      <!-- <div class="item" style="display:block">
         <span>项目描述</span>
         <div class="tip">
             {{detailInfo.ProRemark}}
         </div>
     </div> -->
    </div>
    <div class="page-project-wrap box">
      <div class="item">
        <span>业务人员：</span>{{ detailInfo.UserName }}
      </div>
      <div class="item">
        <span>创建时间：</span>{{ detailInfo.CreateTime }}
      </div>
      <div class="item">
        <span>事件说明：</span>{{ detailInfo.IncidentContent }}
      </div>
      <div class="item" style="display:block">
        <img class="img" @click="imgpreview(detailInfo.Imgs)" v-for="(item,index) in detailInfo.Imgs" :key="index" :src="item" alt="">
      </div>
    </div>


    <!-- 审核 -->
    <div class="review-btn" v-if="detailInfo.IncidentStatus==0&&detailInfo.OperationStatus==1">
      <div class="btn btn1" @click="handleAudit(0)">驳 回</div>
      <div class="btn btn2" @click="handleAudit(1)">通 过</div>
    </div>

    <!-- 添加处理记录 -->
    <div class="review-btn"
         v-if="(detailInfo.IncidentStatus==1&&detailInfo.OperationStatus==1)||(detailInfo.IncidentStatus==4&&detailInfo.OperationStatus==1)">
      <div class="btn btn1" @click="handleAddRecord(0)">添加记录</div>
      <div class="btn btn2" @click="handleAddRecord(1)">完成处理</div>
    </div>
    <van-dialog v-model="show" :title="title" show-cancel-button @confirm="handleConfirm" :before-close="beforeClose" @cancel="show=false">
      <div class="dialog-inner">
        <textarea class="textarea" v-model="Content" placeholder="请输入内容"></textarea>
        <van-uploader v-if="type==1" style="margin-top:10px" v-model="AuditImgs" max-count="5" :after-read="afterRead" multiple/>
      </div>
    </van-dialog>


    <!-- 验收 -->
    <div class="review-btn" v-if="detailInfo.IncidentStatus==2&&detailInfo.OperationStatus==1">
      <div class="btn btn1" @click="handleCheck(0)">驳 回</div>
      <div class="btn btn2" @click="handleCheck(1)">验 收</div>
    </div>

    <!-- 复核 -->
    <div class="review-btn" v-if="detailInfo.IncidentStatus==3&&detailInfo.OperationStatus==1">
      <div class="btn btn1" @click="handleCheckAgain(0)">驳 回</div>
    </div>


    <!-- <van-popup v-model="showWeight" position="bottom" >
        div.
    </van-popup>  -->

    <!-- <div class="bottom-wrap">
        <div class="bottom">
            <div class="review-btn" v-if="detailInfo.IncidentStatus==0&&detailInfo.OperationStatus==1">
                <div class="btn btn1" @click="handleAudit(0)">驳  回</div>
                <div class="btn btn2" @click="handleAudit(1)">通  过</div>
            </div>
        </div>
    </div> -->
    <!-- van-img -->

  </div>
</template>

<script>
import {ImagePreview} from 'vant'

export default {
  data() {
    return {
      detailInfo: {
        Imgs: [],
        AuditList: []
      },
      usersysno: localStorage.getItem('UserSysno'),
      IsSatis: 0,
      countDownTime: 0,

      // 处理弹窗
      show: false,
      title: '',
      type: 0,
      status: '',
      AuditImgs: [],
      Content: '',

    }
  },
  mounted() {
    this.IsSatis = localStorage.getItem('IsSatis')
    // 获取详情
    this.WebGetIncidentInfo(this.$route.query.sysno);

  },
  methods: {
    // 详情
    WebGetIncidentInfo(sysno) {
      let data = {
        IncidentSysno: sysno,
        UserSysno: localStorage.getItem('UserSysno'),
        QDetail: localStorage.getItem('IsSatis') || 0,
      }
      this.$baseajax.normalJsonp(this.$base.baseEvent + '/WebGetIncidentInfo', data, res => {
        console.log(res);
        res = res.WebGetIncidentInfoResult
        if (res.ResponseCode == 1) {
          let detailinfo = res.Item
          this.detailInfo = detailinfo
          this.detailInfo.AuditList.reverse()
          this.countDownTime = new Date(detailinfo.EndTime).getTime() - new Date().getTime()
          // this.IncidentContent = detailinfo.IncidentContent;
          // this.IncidentLevel = detailinfo.IncidentLevel
          // this.IncidentRequire = detailinfo.IncidentRequire;
          // let Imgs = detailinfo.Imgs.reduce((arr,element) => {
          //     arr.push({
          //         url: element,
          //         isImage: true
          //     })
          //     return arr
          // },[]);
          // this.Imgs = Imgs
          // this.EndTime = detailinfo.EndTime
          // this.activeId = detailinfo.DealUserSysno
          // this.activeNameOne = detailinfo.DealUserName

        }
      }, err => {
      })
    },


    // 审核通过、不通过
    handleAudit(status) {
      this.title = "审核"
      this.type = 0
      this.status = status
      this.show = true

      // this.$dialog.confirm({
      //     title:'提示',
      //     message:'确认操作吗？' ,
      //     confirmButtonColor: '#D32F2F'
      // }).then(()=>{
      //     this.WebDAuditIncidentInfo(status,type)
      // }).catch(()=>{})

    },
    handleAddRecord(status) {
      this.title = "添加记录"
      this.type = 1
      this.status = status
      this.show = true
    },
    handleCheck(status) {
      this.title = "验收"
      this.type = 2
      this.status = status
      this.show = true
    },
    handleCheckAgain(status) {
      this.title = "审核"
      this.type = 3
      this.status = status
      this.show = true
    },
    handleConfirm() {
      if (this.type == 0) {
        this.WebDAuditIncidentInfo(this.status)
      } else if (this.type == 1) {
        this.WebDDealIncidentInfo(this.status)
      } else if (this.type == 2) {
        this.WebDAcceptIncidentInfo(this.status)
      } else if (this.type == 3) {
        this.WebDCheckIncidentInfo(this.status)
      }
    },
    beforeClose(action, done) {
      done(false)
    },
    // 审核
    WebDAuditIncidentInfo(status) {
      if (!this.Content) {
        this.$toast('请输入内容')
        return
      }
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        // message: '倒计时 3 秒',
      });
      let data = {
        IncidentSysno: this.$route.query.sysno,
        IncidentAuditStatus: status,//0不通过  1通过
        Content: this.Content,
        AuditUserSysno: localStorage.getItem('UserSysno'),
      }
      console.log(data);
      // debugger
      this.$baseajax.sliceRequest(this.$base.baseEvent + '/WebDAuditIncidentInfo', data, res => {
        console.log(res);
        this.$toast.clear()
        if (res.ResponseCode == 1) {
          this.$toast('操作成功')
          // this.$router.back()
          this.$router.go(-1);
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },

    // 处理
    WebDDealIncidentInfo(status) {
      if (!this.Content) {
        this.$toast('请输入处理过程')
        return
      }
      if (this.AuditImgs.length <= 0) {
        this.$toast('请上传图片')
        return
      }
      let AuditImgs = []
      this.AuditImgs.forEach(item => {
        AuditImgs.push(item.url)
      })
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        // message: '倒计时 3 秒',
      });
      let data = {
        IncidentSysno: this.$route.query.sysno,
        IncidentAuditStatus: status,//0不通过  1通过
        Content: this.Content,
        AuditUserSysno: localStorage.getItem('UserSysno'),
        AuditImgs: AuditImgs
      }
      console.log(data);
      // debugger
      this.$baseajax.sliceRequest(this.$base.baseEvent + '/WebDDealIncidentInfo', data, res => {
        console.log(res);
        this.$toast.clear()
        if (res.ResponseCode == 1) {
          this.$toast('操作成功')
          // this.$router.back()
          this.$router.go(-1);
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },

    // 验收
    WebDAcceptIncidentInfo(status) {
      if (!this.Content) {
        this.$toast('请输入内容')
        return
      }
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        // message: '倒计时 3 秒',
      });
      let data = {
        IncidentSysno: this.$route.query.sysno,
        IncidentAuditStatus: status,//0不通过  1通过
        Content: this.Content,
        AuditUserSysno: localStorage.getItem('UserSysno'),
      }
      console.log(data);
      // debugger
      this.$baseajax.sliceRequest(this.$base.baseEvent + '/WebDAcceptIncidentInfo', data, res => {
        console.log(res);
        this.$toast.clear()
        if (res.ResponseCode == 1) {
          this.$toast('操作成功')
          // this.$router.back()
          this.$router.go(-1);
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },
    // 复核
    WebDCheckIncidentInfo(status) {
      if (!this.Content) {
        this.$toast('请输入内容')
        return
      }
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        // message: '倒计时 3 秒',
      });
      let data = {
        IncidentSysno: this.$route.query.sysno,
        IncidentAuditStatus: status,//0不通过  1通过
        Content: this.Content,
        AuditUserSysno: localStorage.getItem('UserSysno'),
      }
      console.log(data);
      // debugger
      this.$baseajax.sliceRequest(this.$base.baseEvent + '/WebDCheckIncidentInfo', data, res => {
        console.log(res);
        this.$toast.clear()
        if (res.ResponseCode == 1) {
          this.$toast('操作成功')
          // this.$router.back()
          this.$router.go(-1);
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },
    afterRead(file) {
      console.log(file);
      let arr = []
      if (file instanceof Array) {
        arr = file
      } else {
        arr[0] = file
      }
      arr.forEach(item => {
        let formData = new FormData()
        formData.append('file', item.file)
        this.$baseajax.postFile(this.$base.basePic, formData, res => {
          item.url = res.Data
        }, err => {
          console.log(err);
        })
      })
    },
    imgpreview(list) {
      console.log('imgpreview');
      ImagePreview({
        images: list,
        // asyncClose: true,
      });
    }

  },
}

</script>


<style lang="less" scoped>
/deep/ .van-step__circle {
  // background: #D32F2F;
}

.bottom-wrap {
  height: 2rem;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .bottom {
    box-shadow: 0px -2px 4px rgba(201, 201, 201, 0.16);
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    // justify-content: space-between;
    // justify-content: center;
    align-items: center;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: .3rem .4rem;
    z-index: 10;
    padding-bottom: calc(.3rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(.3rem + env(safe-area-inset-bottom));
  }

  .review-btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

}

.page-project-record-wrap {
  h3 {
    margin-top: 0.1rem;
    font-weight: normal;
    font-size: .4rem;
    color: #333;
  }

  .img-wrap {
    display: flex;
    flex-wrap: wrap;

    img {
      margin-right: 5px;
      margin-top: 10px;
      width: 1.4rem;
      height: 1.4rem;
      object-fit: cover;
    }
  }
}

.gc-page-project-wrap {
  .jindu-slider {
    margin-top: 0.7rem;
    opacity: 1;

    /deep/ .custom-button {
      position: relative;
      font-size: 0.28rem;
      color: #666666;
      width: 0.39rem;
      height: 0.39rem;
      border-radius: 100%;
      background-color: #D32F2F;
      box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.4);

      span {
        position: absolute;
        bottom: -0.7rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.project-end-wrap {
  margin: .28rem .28rem 0;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  line-height: 2;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .item {
    display: flex;
    align-items: center;
    padding: .4rem 0;
    border-top: 1PX solid #eee;
    font-size: 0.37rem;
    color: #666666;

    &:first-child {
      border-top: none;
    }

    span {
      width: 3rem;
      flex: 0 0 3rem;
      color: #333333;
    }

    .money {
      padding: .15rem .2rem;
      margin-left: 0.1rem;
      line-height: 1;
      width: 2.6rem;
      // min-width: 2rem;
      font-size: 0.37rem;
      color: #666666;
      background-color: #f0f0f0;
      border-radius: 0.13rem;
    }
  }
}

.page-jindu2-wrap {
  padding-top: .2rem;
  padding-bottom: .2rem;

  .title {
    font-size: 0.37rem;
    color: #333333;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .jindu {
      font-size: 0.7rem;
      color: #D32F2F;
    }
  }
}

.page-status-wrap {
  padding: .4rem 0;

  .status {
    display: flex;
    align-items: center;
    font-size: 0.46rem;
    font-weight: bold;
    color: #333333;
    padding: 0 .3rem;
  }

  img {
    margin-right: 0.3rem;
    width: 0.5rem;
    height: 0.5rem;
  }

  .time-wrap {
    margin-top: 0.2rem;
    margin-left: 0.78rem;
    font-size: 0.34rem;
    color: #666;
    // color: #D32F2F;
    display: flex;
    align-items: center;
  }

  .time {
    color: #D32F2F;
  }
}

.dialog-inner {
  width: 90%;
  margin: 20px auto;
}

.textarea {
  display: block;
  width: 100%;
  height: 100px;
  padding: 5px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
}

// .gc-page-project-wrap{
//     .box{
//         margin: .28rem .28rem 0;
//         padding-left: 0.5rem;
//         padding-right: 0.5rem;
//         line-height: 2;
//         background-color: #ffffff;
//         box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
//         border-radius: 0.27rem;
//         .item{
//             display: flex;
//             padding: .4rem 0;
//             border-top: 1PX solid #eee;
//             font-size: 0.37rem;
// 	        color: #666666;
//             &:first-child{
//                 border-top: none;
//             }
//             span{
//                 width: 2rem;
//                 flex: 0 0 2rem;
//                 // font-size: 0.4rem;
// 	            color: #333333;
//             }
//         }
//         .tip{
//             margin-top: 0.3rem;
//             min-height: 3rem;
//             background-color: #f0f0f0;
//             border-radius: 0.13rem;
//             line-height: 1.6;
//             padding: .2rem .3rem;
//             font-size: 0.37rem;
// 	        color: #666666;
//         }
//     }
//     .page-member-wrap{
//         padding-top: .5rem;
//         padding-bottom: .5rem;
//         text-align: center;
//         position: relative;
//         &:after{
//             content: '';
//             position: absolute;
//             left: 46%;
//             top: 0.5rem;
//             bottom: 0.5rem;
//             width: 1PX;
//             background: #eee;
//         }
//         .s1{
//             width: 50%;
//             padding-right: 10%;
//             text-align: left;
//         }
//         .s2{
//             width: 25%;
//             display: flex;
//             justify-content: space-around;
//             .btn{
//                 padding: .1rem .2rem;
//                 font-size: 0.27rem;
//                 border-radius: 0.13rem;
//                 border: solid 1PX #D32F2F;
//                 &.btn1{
//                     color: #D32F2F;
//                 }
//                 &.btn2{
//                     color: #fff;
//                     background-color: #D32F2F;
//                 }
//             }
//         }
//         .title{
//             display: flex;
//             margin-bottom: 0.2rem;
//             font-size: 0.37rem;
//             color: #333333;
//             justify-content: space-between;
//         }
//         .info-wrap{
//             font-size: 0.27rem;
// 	        color: #666666;
//             .info-item{
//                 margin-top: 0.2rem;
//                 display: flex;
//                 justify-content: space-between;
//             }
//         }
//         .input-wrap{
//             width: 1.3rem;
//             margin-left: auto;
//             margin-right: auto;
//             line-height: 0.6rem;
//             background-color: #f0f0f0;
//             // border: 1px solid #eee;
//             border-radius: 0.13rem;
//             font-size: 0.27rem;
// 	        color: #666666;
//             .input{
//                 width: .7rem;
//                 text-align: center;
//             }
//         }
//     }
//     .page-jindu-wrap{
//         padding-top: .5rem;
//         padding-bottom: 1rem;
//         .title{
//             font-size: 0.37rem;
// 	        color: #333333;
//         }
//     }
//     .jindu-slider{
//         margin-top: 0.7rem;
//         opacity: 1;
//         /deep/.custom-button{
//             position: relative;
//             font-size: 0.21rem;
//             color: #666666;
//             width: 0.39rem;
//             height: 0.39rem;
//             border-radius: 100%;
//             background-color: #D32F2F;
//             box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.4);
//             span{
//                 position: absolute;
//                 bottom: -0.7rem;
//                 left: 50%;
//                 transform: translateX(-50%);
//             }
//         }
//     }
//     .submit-btn{
//         width: 8.8rem;
//         margin: 1rem auto .5rem;
//         height: 1.04rem;
//         line-height: 1.04rem;
//         background-color: #D32F2F;
//         box-shadow: 0rem 1PX 0.09rem 0rem rgba(26, 26, 26, 0.29);
//         border-radius: 0.2rem;
//         font-size: 0.47rem;
//         color: #ffffff;
//         text-align: center;
//     }
//     .review-btn{
//         margin-top: 1rem;
//         margin-bottom: 0.5rem;
//         display: flex;
//         justify-content: space-around;
//         .btn{
//             width: 4rem;
//             padding: .16rem 0;
//             border-radius: 0.2rem;
// 	        border: solid 0.03rem #D32F2F;
//             border-radius: 0.2rem;
//             text-align: center;
//             font-size: 0.47rem;
//             &.btn1{
//                 color: #D32F2F;
//             }
//             &.btn2{
//                 box-shadow: 0rem 0.01rem 0.09rem 0rem rgba(26, 26, 26, 0.29);
//                 background-color: #D32F2F;
//                 color: #ffffff;
//             }
//         }
//     }
// }
</style>



// WEBPACK FOOTER //
// src/views/satisfaction/Detail.vue